import React from 'react';

import { BackgroundImage } from '../../background-image/background-image';

import './lesson-banner-view__image.scss';

interface Props {
    src: string | null;
}

export const LessonBannerViewImage = React.memo(({ src }: Props) => {
    return <BackgroundImage mix="lesson-banner-view__image" objectFit="cover" src={src} />;
});
